import { FC, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { PlanType } from "sdk/types";
import { SimpleNav, Header } from "~/components";
import { LocationState, routes } from "~/constants";
import { useAuthZ } from "~/hooks/useAuthZ";
import { useCurrentUser } from "~/hooks/useCurrentUser";
import { trackPlanSelect as track } from "~/PlanDetailsApp/events";
import { Body, Meta } from "./components";

const types: PlanType[] = ["plus", "premium"];

const PlanSelectPage: FC = () => {
  const currentUser = useCurrentUser();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    membership: { canSeePlanSelect },
  } = useAuthZ();
  const state = location.state as LocationState | null;

  const isOnboarding =
    !currentUser?.isOnboarded || !currentUser?.subscription?.plan;

  useEffect(() => {
    if (!canSeePlanSelect) {
      navigate(routes.settings);
    }
  });

  if (types.includes(state?.type as any)) {
    return <Navigate to={routes.planPayment} state={state} />;
  }

  return (
    <>
      <Meta />
      {isOnboarding ? (
        <SimpleNav
          handleClick={track.goToPreviousPage}
          previousRoute={routes.questionHowDidYouHear}
        />
      ) : (
        <Header />
      )}
      <Body />
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default PlanSelectPage;
